import type { PanelItem } from '../components/panels/types';
import { useAppSelector } from '../store/react_redux_typed';

export function useDefaultFullscreenPanel(availablePanels: PanelItem[]) {
  const rightPanelKeys = availablePanels
    .filter((panel) => panel.side === 'right' && !panel.disabled)
    .map((panel) => panel.key);

  const openedPanels = useAppSelector((state) => state.panels.openedPanels);
  let firstOpenedPanel;
  for (const rightPanelKey of rightPanelKeys) {
    if (openedPanels[rightPanelKey] === true) {
      firstOpenedPanel = rightPanelKey;
      break;
    }
  }

  return firstOpenedPanel ?? rightPanelKeys[0];
}
